<template>
  <div class="planGlobal" :class="[ selected? 'selected': '']" @mouseover="$emit('mouseover')">
    <h2 class="premium planTitle paddingRound flexwrap centercenter" style="grid-column: 1/2; grid-row: 1/2">{{ currentplan.duration }} mois</h2>
    <div class="planBody paddingRound">
      <div class="planContent flexwrap centercenter" style="grid-column: 1/2; grid-row: 2/3; flex-direction: column">
        <div class="flexwrap centercenter" style="align-items: flex-end;">
          <h2 >{{ currentplan.monthly.toFixed(2).replace('.',',') }}€</h2>
          <h2 style="font-size: 0.9em"> /m</h2>
        </div>

        <standard-button :color-class="'olive'" @click="$emit('click')">
          <strong>Sélectionner</strong>
        </standard-button>

        <div style="font-size: 0.9em">{{ currentplan.price.toFixed(2).replace('.',',') }}€</div>
      </div>
      <div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "plan",
  components: {StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue')},
  props: ['selected', 'currentplan'],

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
.planGlobal{
  z-index: 0;
  transition: transform 0.5s;
  display: grid;
  grid-template-rows: auto 1fr auto;
  text-align: center;
  border-radius: 1vw;
  box-shadow: 0 0.1vw 0.3vw 0 hsla(200, 20%, 10%, 0.2), 0 0.1vw 0.5vw 0 hsla(200, 20%, 10%, 0.2);
  overflow: hidden;
  height: 10vw;
  width: 10vw;
}

.planBody {
  background-color: var(--goalBackgroundColor3);
}
.planContent{
  align-content: space-evenly ;
  justify-content: space-evenly;
  height:100%;
}

.selected{
  z-index: 1;
  /*border: 0.2vw solid #3b49a5;*/
  transform: scale(1.1)
}

.planTitle{
  font-weight: bold;
  height: 2vw;
}
@media screen and (max-device-width: 767px) {

  .planGlobal{
    margin-top: 2vw;
    margin-bottom: 2vw;
    border-radius: 3vw;
    box-shadow: 0 0.1vw 0.3vw 0 hsla(200, 20%, 10%, 0.2), 0 0.1vw 0.5vw 0 hsla(200, 20%, 10%, 0.2);
    height: 50vw;
    width: 40vw;
  }
  .planBody{
    padding: 3vw;
    border-radius: 0 0 3vw 3vw;
  }
  .planContent{
  }

  .planTitle{
    border-radius: 3vw 3vw 0 0;
    height: 10vw;
  }

  .selected{
    z-index: 1;
    transform: scale(1.1)
  }

}
</style>